<template>
    <span class="convention-select" v-if="user">
        <action
            @click="selectConfirm = true"
            v-if="!canViewAllConventions && canAddConvention(parentConvention)"
            name="link"
            with-icon="mdi-star-outline"
            :nochevron="true"
            :small="true"
        >
            Sélectionner cette convention
        </action>

        <action
            v-if="canViewAllConventions && !hasConvention(parentConvention)"
            @click="select"
            name="link"
            color-icon="#0052FF"
            with-icon="mdi-star-outline"
            :loading-icon="selectLoading"
            :nochevron="true"
            :small="true"
        >
            Ajouter aux favoris
        </action>

        <action
            v-if="canViewAllConventions && hasConvention(parentConvention)"
            @click="removeConfirm = true"
            name="link"
            with-icon="mdi-star"
            color-icon="#0052FF"
            :nochevron="true"
            :loading-icon="removeLoading"
            :small="true"
        >
            Supprimer des favoris
        </action>

        <v-dialog v-model="selectConfirm" persistent max-width="600">
            <v-card>
                <v-card-title class="headline">Sélectionner une convention collective</v-card-title>
                <v-card-text
                    >Êtes-vous sûr de sélectionner cette convention collective ? Cette action est
                    irréversible.</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" text @click="selectConfirm = false">Annuler</v-btn>
                    <v-btn
                        color="darken-1"
                        class="ok"
                        text
                        @click="
                            selectConfirm = false;
                            select();
                        "
                        >OK</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="removeConfirm" persistent max-width="600">
            <v-card>
                <v-card-title class="headline">Supprimer des favoris</v-card-title>
                <v-card-text>
                    Etes-vous sûr de vouloir supprimer cette convention de vos favoris
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darken-1" text @click="removeConfirm = false">Annuler</v-btn>
                    <v-btn
                        color="darken-1"
                        class="ok"
                        text
                        @click="
                            removeConfirm = false;
                            remove();
                        "
                        >OK</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import userMixin from "src/mixins/user";
import { EventBus } from "src/bus/eventBus";

export default {
    props: ["parentConvention", "user"],
    data() {
        return {
            selectConfirm: false,
            selectLoading: false,
            removeConfirm: false,
            removeLoading: false,
        };
    },
    methods: {
        async select() {
            this.selectLoading = true;
            await this.selectConvention(this.parentConvention);
            this.selectLoading = false;
            EventBus.$emit("convention:force-update");
        },
        async remove() {
            this.removeLoading = true;
            await this.removeConvention(this.parentConvention);
            this.removeLoading = false;
            EventBus.$emit("convention:force-update");
        },
    },
    mixins: [userMixin],
};
</script>

<style scoped lang="sass">
.action + .action
    margin-left: $grid-gutter

.ok
    color: $color-main
</style>
